export default __webpack_public_path__ + "static/media/APACHE RTR 180 2V_3.b7412a4a.webp";